// const currentUserId = currentUser && currentUser.user.Pi.itemId;

import { alertUtil } from "./alertUtil";
import { areaUtil } from "./areaUtil";

export const subclienteUtil = (subcliente) => ({
  ...subcliente,

  areas: subcliente.areas ? subcliente.areas.map((area) => areaUtil(area)) : [],

  alertas: subcliente.alertas && Array.isArray(subcliente.alertas) ? subcliente.alertas.map((alerta) => alertUtil(alerta)) : [],

  isOwner(user) {
    // recorrer las areas del subcliente y verificar si el usuario es responsable o lider de alguna
    return this.areas.some((area) => area.isOwner(user));
  },
});
